import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-burn-test',
  templateUrl: './burn-test.component.html',
  styleUrls: ['./burn-test.component.css']
})
export class BurnTestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
